module.exports = {
  "AccountLoaded": "AccountLoaded",
  "GalleryLoaded": "GalleryLoaded",
  "LibraryLoaded": "LibraryLoaded",
  "LibraryPhotoToggled": "LibraryPhotoToggled",
  "GalleryDetailsUpdated": "GalleryDetailsUpdated",
  "EditGalleryLoaded": "EditGalleryLoaded"
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvc3RhdGUvQWN0aW9uTmFtZXMuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL2FwcC9zcmMvc3RhdGUvQWN0aW9uTmFtZXMuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxPQUFQLEdBQWlCO0VBQ2hCLGlCQUFBLGVBRGdCO0VBRWhCLGlCQUFBLGVBRmdCO0VBR2hCLGlCQUFBLGVBSGdCO0VBSWhCLHVCQUFBLHFCQUpnQjtFQUtoQix5QkFBQSx1QkFMZ0I7RUFNaEIscUJBQUEsbUJBTmdCIn0=
